import arrayToOrderedMap from '../arrayToOrderedMap'
import { formatPrice } from '../formatPrice'

/**
 * takes a payment method from our database and parses
 * it so that it becomes more UI friendly
 * @param {array} | [ paymentMethods ]
 * @returns {array}
 */
export const parsePaymentMethodsFromSource = (
  source,
  isImmutableData = false,
) => {
  const parsed = source.map(m => {
    let name = (m.brand ? m.brand : m.bank) || ''
    if (m.issuer === 'PAYTIENT') {
      name = 'Paytient'
    }

    const label =
      m.type === 'ACCOUNT_CREDIT'
        ? `Account credit (${formatPrice(m.amount, '$0', true)} available)`
        : `${name} ending in ${m.last4}`

    return {
      ...m,
      name,
      last4: m.last4,
      label,
      icon: name.toLowerCase(),
      value: m.id,
      isPrimary:
        m.primaryForSubscription ||
        m.primaryForExpense ||
        m.primaryForFinancing,
    }
  })
  return isImmutableData ? arrayToOrderedMap('id')(parsed) : parsed
}

/**
 * removes added fields from payment method so we can
 * send it back to backend as they expect
 * @param {object} paymentMethod
 * @returns {object}
 */
export const parsePaymentMethodsToPayload = paymentMethod => {
  const paymentMethodCopy = Object.assign({}, paymentMethod)
  const keysToDelete = ['name', 'icon', 'label', 'value', 'isPrimary']
  keysToDelete.forEach(key => {
    delete paymentMethodCopy[key]
  })
  return paymentMethodCopy
}
